import { AxiosError } from 'axios';

export const isAxiosError = (error: unknown): error is AxiosError => ('isAxiosError' in (error as any)) && (error as AxiosError).isAxiosError;
